const Constants = {
    StageType: {
      HOLD: 1,
      QPCR: 2,
      MELT_CURVE: 3,
      PCR: 4 // Without fluorescence measurement
    }
  };
  module.exports = Constants;